// extracted by mini-css-extract-plugin
export default {"mobileLayout":"MobileLayout_mobileLayout__nBNrN","card":"MobileLayout_card__wCIN4"};